import Main from "@/views/Main";
import Details from "@/views/Details";
import Router from "vue-router";
import Vue from "vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "main",
      component: Main,
      props: true
    },
    {
      path: "/:address",
      name: "details",
      component: Details,
      props: true
    },
    // {
    //   path: "/passport",
    //   component: Passport,
    //   props: true,
    //   children: [
    //     {
    //       path: "",
    //       name: "passport"
    //     },
    //     {
    //       path: ":passport",
    //       name: "passport-view"
    //     }
    //   ]
    // },
    { path: "*", redirect: "/" }
  ]
});
